function sloaded(){
    $('body').addClass('loaded sloaded');
}

window.addEventListener('load', (event) => {
	sloaded();
});